<template>
  <div v-html="content" class="xieyi"></div>
</template>
<style scoped lang="less" rel="stylesheet/less">
    .xieyi{
      padding:20px;
      line-height:25px;
      text-align:left;
      font-size:14px
    }
</style>
<script type="text/ecmascript-6">
  import {getHtmlWeb} from "../../http";

    export default {
       name: "html",
       props:[],
       data() {
         return{
           content:this.$route.query.content,      //页面内容
           title:this.$route.query.title,      //页面标题
         }
       },
      methods:{},
      created() {
      }
    }
</script>




// WEBPACK FOOTER //
// src/components/buy/sliderhtml.vue